// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z2aTf","col":"styles_col__3ZQ_6"};